module.exports = __webpack_public_path__ + "img/卷纸.08ac03ac.png";